import React from 'react';
import {UserInfo} from "../user-info/user-info.component";
import {UserInfoLabelBox} from "../user-info/user-info-label.box";
import {UserMenuSectionBox} from '../user-menu/user-menu/boxes/user-menu-section.box';
import {useServices} from '../../react-hooks/use-services.hook';
import {UserMenuNameBox} from './boxes/user-menu-name.box';
import {UserMenuSupportIdBox} from './boxes/user-menu-support-id.box';
import {FlexContainerBox, FlexFixedSizeItemBox, FlexGrowItemBox, FlexShrinkItemBox} from "../../themes/architecture/css-helpers/flex";
import {UserData} from '../../services/sdk/sdk.service.interface';
import {ITranslationService} from '../../services/translation/translation.service.interface';
import {Image} from '../raw-components/image/image';

export const UserDetails: React.FC = () => {
    let services = useServices();
    const {showUserTitle, showFirstName, showLastName} = services.configuration.data.drawer.welcomeMessage;
    const avatarUrl = services.configuration.data.generalSettings.avatarUrl.drawer.regular;

    function _renderUserTitle(isEnabled: boolean, translator: ITranslationService) {
        if(!isEnabled)
        return null;

        const userGenderTitle = this.services.user.genderTitle;
        return <span>{translator.translate(userGenderTitle)}</span>
    }

    function _renderUserInfo(infoType: keyof UserData, isEnabled: boolean) {
        if(!isEnabled)
        return null;

        return <UserInfo className="cy-user-name" selectedUserInfo={infoType} />;
    }

    function _renderLeftPart() {
        let smallViewport = services.mediaQuery.lAndBelow;
        if (smallViewport) {
            return <FlexFixedSizeItemBox style={{marginRight: "1.6rem"}}>
                <Image src={avatarUrl} alt="" />
            </FlexFixedSizeItemBox>;
        } else {
            return <FlexShrinkItemBox flexShrink={100} flexBasis="1.2rem"></FlexShrinkItemBox>;
        }
    }

    const RightArrowIcon = services.theme.currentTheme.icons.forwardIcon;

    return (
        <UserMenuSectionBox className="cy-user-menu-user-details" onClick={() => { services.userMenu.launchMyAccount() }}>
            <FlexContainerBox alignItems="center" style={{cursor: "pointer"}}>
                { _renderLeftPart() }
                <FlexGrowItemBox>
                    <UserMenuNameBox>
                        {_renderUserTitle(showUserTitle, services.translation)}
                        {_renderUserInfo('firstName', showFirstName)}
                        {_renderUserInfo('lastName', showLastName)}
                    </UserMenuNameBox>
                    <UserMenuSupportIdBox>
                        <UserInfoLabelBox>{services.translation.translate('SUPPORT_ID_MESSAGE')}</UserInfoLabelBox>
                        <UserInfo className="user-cid cy-user-cid" selectedUserInfo="cid" />
                    </UserMenuSupportIdBox>
                </FlexGrowItemBox>
                <FlexFixedSizeItemBox>
                    <RightArrowIcon size={1.2} />
                </FlexFixedSizeItemBox>
            </FlexContainerBox>
        </UserMenuSectionBox>
    );
};
